import { HttpClient, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '.';

@Injectable({
	providedIn: 'root',
})
export class AlarmAgentApiClient extends HttpClient {
	public constructor(handler: HttpHandler, private config: ConfigService) {
		super(handler);
	}

	public get(url: string, options?: Object): Observable<any> {
		url = this.config.apiBaseUrl + url;
		url =
			url +
			(url.indexOf('?') > -1 ? '&' : '?') +
			'cb=' +
			new Date().getTime(); // Cache buster
		return super.get(url, options);
	}

	public post(url: string, body: any, options?: Object): Observable<any> {
		url = this.config.apiBaseUrl + url;
		return super.post(url, body, options);
	}

	public put(url: string, body: any, options?: Object): Observable<any> {
		url = this.config.apiBaseUrl + url;
		return super.put(url, body, options);
	}

	public delete(url: string, options?: Object): Observable<any> {
		url = this.config.apiBaseUrl + url;
		return super.delete(url, options);
	}
}
